'use strict';

module.exports = {
    getUrl: Odigeo._.constant('getrenewalstatus'),
    getMethod: Odigeo._.constant('GET'),
    requestSuccess(data) {
        Odigeo.trigger(`${this.widget.id}:getRenewalStatusOk`, data);
    },
    requestError(error) {
        Odigeo.trigger(`${this.widget.id}:getRenewalStatusFail`, error);
    },
};
